import clientApi from "@/api/clientApi"

export async function confirmDeleteClient(clientId, clientNom, deleteCallback = null) {
    let {isConfirmed} = await this.$swal({
        title: 'Supprimer Client',
        text: `Etes-vous sûr de vouloir supprimer le client ${clientNom}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmer',
        cancelButtonText: "Annuler",
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
    })

    if(isConfirmed)
        await this.deleteClient(clientId, deleteCallback);
}

export async function deleteClient(clientId, deleteCallback = null) {
    if(this.hasOwnProperty("deleting"))
        this.deleting = true;
    try {
        await clientApi.deleteClient(clientId);
        this.showToast("success", "Client supprimé", "CheckIcon")
        if(deleteCallback != null && typeof deleteCallback === "function")
            deleteCallback(clientId);
        
    } catch(e) {
        console.log("e", e)
        this.showToast("danger", "Une erreur s'est produite", "AlertCircleIcon")
    }
    finally {
        if(this.hasOwnProperty("deleting"))
            this.deleting = false;
    }
}